import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import AppPerformanceOverviewCommon from '../../../../containers/OverView/AppPerformanceOverviewCommon';

const scorecards: OverviewComponentType[] = [];

// Provide a default custom overview.
const customOverview: OverviewComponentType | null = () => (
  <AppPerformanceOverviewCommon />
);

const pepsiTastyRewardsRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default pepsiTastyRewardsRegistry;
